import { EMAIL_VERIFIED } from '../constants/actions';
import auth, { IConfirmSignUp } from '../services/auth';

export default async (formData: IConfirmSignUp): Promise<string> => {
    try {
        await auth.confirmSignUp(formData);
        return EMAIL_VERIFIED;
    } catch (error) {
        if (error instanceof Error) {
            return error.message as string;
        }
        return 'UNKOWN';
    }
};
